"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { CustomCursorArea } from "@repo/ui/custom-cursor";
import { Carousel, CarouselContent, CarouselItem, CarouselNavButtons, CarouselProgressBar } from "@repo/ui/carousel";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { RichTextCaption } from "@/components/common/rich-text/rich-text-caption.component";
import type { ImageCarouselMultipleProps } from "./image-carousel-multiple.types";
function PaginationRow() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="unconstrained-grid mt-8 items-center gap-4 desktop:mt-16 desktop:gap-6"><CarouselNavButtons breakpoint="desktop" variant="grey" className="col-span-1 tablet:col-span-4" /><CarouselProgressBar className="h-1 col-span-3 tablet:col-span-8 bg-surface-base-secondary desktop:h-2" indicatorClassName="inset-y-0 bg-surface-base-disabled" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function ImageCarouselMultipleInner(t0) {
  const $ = _c(10);
  const {
    slides
  } = t0;
  let t1;
  if ($[0] !== slides) {
    t1 = slides.map(_temp);
    $[0] = slides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="shrink-0 grow-0 basis-4 desktop:basis-16" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <CustomCursorArea type="drag"><CarouselContent viewportClassName="pl-4 desktop:pl-16" className="-ml-2">{t1}{t2}</CarouselContent></CustomCursorArea>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== slides.length) {
    t4 = slides.length > 1 && <PaginationRow />;
    $[5] = slides.length;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(slide) {
  return <CarouselItem key={slide.key} className="basis-[79.8%] pl-2 desktop:basis-[63.4%]"><div className="flex flex-col gap-4 tablet:gap-6"><div className="h-[196px] overflow-hidden rounded-sm tablet:h-[572px] tablet:rounded-md"><VisualWrapper visual={slide.visual} className="size-full" visualClassName="size-full" /></div>{slide.caption && <RichTextCaption richText={slide.caption} />}</div></CarouselItem>;
}
export function ImageCarouselMultiple(t0) {
  const $ = _c(7);
  const {
    slides,
    className
  } = t0;
  if (!slides.length) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("py-5 desktop:py-16", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== slides) {
    t2 = <Carousel align="start" duration={40} dragFree={true} wheelGestures={true}><ImageCarouselMultipleInner slides={slides} /></Carousel>;
    $[2] = slides;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <section className={t1} data-testid="image-carousel-multiple">{t2}</section>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}